
const state = {
    roomChoose: null,
};

const mutations = {
    setRoomData(state, data) {
        state.roomChoose = data;
    },
    resetRoom(state) {
        state.roomChoose = null;
    },
};

const actions = {
    saveRoomChoose({ commit }, room) {
        commit('setRoomData',room)
    },
    resetRoomChoose({ commit }) {
        commit('resetRoom')
    },
};
const getters = {
    getRoomChoose (state) {
        return state.roomChoose
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};